<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>Pool Plans</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="user.permissions.others.uploadPoolPrints" @click="showUploader = !showUploader" class="primary"><v-icon left>{{showUploader ? 'clear' : 'add'}}</v-icon>{{showUploader ? 'Close Uploader' : 'Upload Plan'}}</v-btn>
        </v-toolbar>
        <!-- File Uploader -->
        <v-flex class="mt-4" xs12 pl-3 v-if="showUploader">
          <v-checkbox class="mt-0 pt-0 pb-0" label="Notify Assigned Users" v-model="noteNotifyAssigned" />
          <v-checkbox class="mt-0 pt-0" label="Notify All Users" v-model="noteNotifyAll" />
        </v-flex>
          <uploader v-if="showUploader" @planVersion="planVersion" @filesUploaded="getUploadFiles" @closeUploader="showUploader = false" :singleOnly="true" :uploadPath="'projects/' + this.project.id + '/plans/'"  />
        <!-- End: File Uploader -->
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="projectPlans.length > 0">
    <v-flex sm12 md6 mt-2 pl-2 pr-2>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Latest Pool Plan</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-title primary-title>
          <v-flex text-xs-center>
            <div class="subheading indigo--text">Version: {{projectPlans[0].name}}</div>
            <div class="caption indigo--text">Uploaded: {{ projectPlans[0].timestamp.seconds | moment("from") }}</div>
            <div class="caption indigo--text">Upload Date: {{ projectPlans[0].timestamp.seconds | moment("MMMM Do YYYY") }}</div>
          </v-flex>
        </v-card-title>
        <v-flex pt-3 @click="downloadCurrent(projectPlans[0].url)" style="cursor: pointer">
          <pdf :src="projectPlans[0].url"></pdf>
        </v-flex>
        <v-flex class="text-xs-center">
          <v-btn @click="downloadCurrent(projectPlans[0].url)" round class="secondary">Download Latest</v-btn>
        </v-flex>
      </v-card>
    </v-flex>
    <v-flex sm12 md6 pl-2 pr-2 mt-2>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Pool Plan History</v-toolbar-title>
      </v-toolbar>
      <v-data-table :headers="headers" :items="projectPlans" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td class="subheading">{{ props.item.name }}</td>
          <td class="subheading">{{ props.item.timestamp.seconds | moment("from") }}</td>
          <td><v-icon @click="downloadVersion(props.item.url)" color="primary" large>cloud_download</v-icon></td>
          <td v-if="user.permissions.others.deletePoolPrints"><v-icon @click="deletePlan(props.item)" color="primary" large style="margin-left: -25px; padding-left: -25px">cancel</v-icon></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
  <v-layout v-if="projectPlans.length < 1">
    <v-toolbar>
      <v-toolbar-title>No Pool Plans Found. Please upload a plan to start.</v-toolbar-title>
    </v-toolbar>
  </v-layout>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import Uploader from '../../helpers/Uploader'
import _ from 'lodash'

export default {
  props: ['project'],
  data () {
    return {
      noteNotifyAll: false,
      noteNotifyAssigned: true,
      fileVersion: null,
      showUploader: false,
      uploadedFileList: [],
      headers: [
          { text: 'Revision Date', value: 'version', sortable: false },
          { text: 'Uploaded', value: 'upload_date', sortable: false },
          { text: '', value: 'download', sortable: false }
      ]
    }
  },
  mounted () {
    this.getProjectPlans()
  },
  watch: {
    noteNotifyAssigned () {
      if (this.noteNotifyAssigned) {
        this.noteNotifyAll = false
      }
    },
    noteNotifyAll () {
      if (this.noteNotifyAll) {
        this.noteNotifyAssigned = false
      }
    }
  },
  computed: {
    projectPlans () {
      const plans = this.$store.getters.projectPlans
      return _.orderBy(plans, 'timestamp.seconds', ['desc'])
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    deletePlan (plan) {
      if (confirm('Are you sure you want to delete this pool plan ?')) {
        this.$store.dispatch('deleteProjectPlan', {projectId: this.project.id, project_name: this.project.name, plan: plan})
      }
    },
    planVersion (newPlanVersion) {
      this.fileVersion = newPlanVersion
    },
    reloadPlans () {
      this.$emit('reloadPlans')
    },
    getProjectPlans () {
      this.$store.dispatch('getProjectPlans', this.project.id)
    },
    getUploadFiles (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        let selectedFileExtension = value.ref.name.split('.').pop()
        this.uploadedFileList.push({project_id: this.project.id, name: this.fileVersion, type: value.metadata.contentType, extension: selectedFileExtension, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true})
        const payload = {project_id: this.project.id, project_name: this.project.name, files: this.uploadedFileList}
        this.$store.dispatch('newProjectPlan', payload)
        this.reloadPlans()
        // Send Notifications if Any
        if (this.noteNotifyAll || this.noteNotifyAssigned) {
          let emails = []
          // Get Notification Emails
          let users = Object.assign([], this.$store.getters.userList)
          // Filter Out The Current User
          users.splice(users.findIndex(i => i.id === this.$store.getters.user.id), 1)
          if (this.noteNotifyAll) {
            emails = users.map(user => user.email)
          }
          if (this.noteNotifyAssigned) {
            this.project.assigned_to.forEach(assigned => {
              const userEmail = users.filter(f => f.id === assigned)[0]
              if (userEmail) {
                emails.push(userEmail.email)
              }
            })
          }
          if (emails.length > 0) {
            const emailSubject = 'New Pool Plan For Project: ' + this.project.name
            const title = this.user.first_name + ' ' + this.user.last_name + ' Added A New Pool Plan To The Project: ' + this.project.name
            const message = 'There is a new pool plan for the project: ' + this.project.name + ' (Revision: ' + this.fileVersion + ' ). Make sure you have the latest.'
            const url = this.$store.getters.clientSettings.baseUrl + '/project/' + this.project.id
            const icon = 'border_outer'
            this.$store.dispatch('notify', {emails, emailSubject, title, message, url, icon})
            this.noteNotifyAll = false
            this.noteNotifyAssigned = false
          }
        }
      })
    },
    downloadCurrent (url) {
      window.open(url)
    },
    downloadVersion (item) {
      window.open(item)
    }
  },
  components: {
    pdf,
    Uploader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/ProjectPlans.vue